import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { inRoomDiningItemsSelector } from '../../../servicesSlice';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';

const ItemsViewUpsell = (props) => {
  const { selectedItem } = props;
  const [loading, setLoading] = useState(true);
  const originalUpsellItems = useSelector(inRoomDiningItemsSelector);
  const [upsellItem, setUpsellItem] = useState([]);

  useEffect(() => {
    if (selectedItem.upsell.status) {
      const tempUpsellItems = originalUpsellItems.filter((item) => {
        return selectedItem.upsell.items.includes(item.id);
      });
      setUpsellItem(tempUpsellItems);
    }
    setLoading(false);
  }, [selectedItem]);

  return (
    <>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : selectedItem && selectedItem.upsell.status && upsellItem.length > 0 ? (
        <>
          <div className='row mx-4 mt-4'>
            <div className='col-md-12'>
              <div className='details-label mb-2'>Upsell Items</div>
              {upsellItem.map((upItem, index) => (
                <div className='details-value mb-1' key={index}>
                  {upItem.name}
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='row mx-4 mt-4'>
            <div className='col-md-6'>
              <div className='details-label'>No Upsell Items Available</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ItemsViewUpsell;
